export * from './base.model';
export * from './dictType.model';
